module.exports = {
  emptyMessage: 'Hey! You forgot to fill in your card number.',
  defaultMessage: 'The card number you entered is invalid. Make sure there wasn\'t a typo and try again.',
};
